import { TaskType } from '@/pages/Facility/Config/FreshTask/FreshTaskContants';
import {
  adjAllocateQty, cancelTask,
  commit,
  sowTaskCommit,
  sowTaskConfirm,
  confirm,
  fetchPickingSowTask,
  fetchTask,
  getByPsTaskUuid, print, queryLog, queryPickerTaskPanel,
  queryPickingTasks,
  querySowingTasks,
  queryUnPickingTasks,
  queryUnSowingTasks,
  verifyPickingContainer, verifyPickQty,
  verifySowingContainer
} from '@/services/forward/out/FreshPickUp';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'freshPickUp',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/freshPickUp") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    entity: {},
    printList: [],
    electronicList: [],
    showPage: 'query',
    pickingTask: [],
    sowTask: []
  },
  effects: {
    *queryPickerTaskPanel({ payload, callback }, { call, put }) {
      const response = yield call(queryPickerTaskPanel, payload);
      if (response && response.success) {
        yield put({
          type: 'saveTaskPanel',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },
    *queryUnPickingTasks({ payload, callback }, { call, put }) {
      const response = yield call(queryUnPickingTasks, payload);
      if (response && response.success) {
        yield put({
          type: 'saveUnPickingTasks',
          payload: response.data
        });
      }
      if (callback) callback(response);

    },
    *queryUnSowingTasks({ payload, callback }, { call, put }) {
      const response = yield call(queryUnSowingTasks, payload);
      if (response && response.success) {
        yield put({
          type: 'saveUnSowingTasks',
          payload: response.data
        });
      }
      if (callback) callback(response);

    },
    *queryLog({ payload, callback }, { call, put }) {
      const response = yield call(queryLog, payload);
      if (callback) callback(response);
    },
    *print({ payload, callback }, { call, put }) {
      const response = yield call(print, payload);
      if (callback) callback(response);
    },
    *queryPickingTasks({ payload }, { call, put }) {
      const response = yield call(queryPickingTasks, payload);
      if (response && response.success) {
        yield put({
          type: 'savePickingTasks',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },
    *querySowingTasks({ payload }, { call, put }) {
      const response = yield call(querySowingTasks, payload);
      if (response && response.success) {
        yield put({
          type: 'saveSowingTasks',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },
    *fetchTask({ payload, callback }, { call, put }) {
      const response = yield call(fetchTask, payload);
      if (callback) callback(response);
    },
    *fetchPickingSowTask({ payload, callback }, { call, put }) {
      const response = yield call(fetchPickingSowTask, payload);
      if (response && response.success) {

        if (TaskType.PICKING.name === payload.type) {

          yield put({
            type: 'savePickingTask',
            payload: response.data
          })
        } else if (TaskType.SOW.name === payload.type) {

          yield put({
            type: 'saveSowTask',
            payload: response.data
          })
        }
      }
      if (callback) callback(response);
    },
    *cancelTask({ payload, callback }, { call, put }) {
      const response = yield call(cancelTask, payload);
      if (callback) callback(response);
    },
    *sowTaskCommit({ payload, callback }, { call, put }) {
      const response = yield call(sowTaskCommit, payload);
      if (callback) callback(response);
    },
    *commit({ payload, callback }, { call, put }) {
      const response = yield call(commit, payload);
      if (callback) callback(response);
    },
    *confirm({ payload, callback }, { call, put }) {
      const response = yield call(confirm, payload);
      if (callback) callback(response);
    },
    *sowTaskConfirm({ payload, callback }, { call, put }) {
      const response = yield call(sowTaskConfirm, payload);
      if (callback) callback(response);
    },
    *verifyPickingContainer({ payload, callback }, { call, put }) {
      const response = yield call(verifyPickingContainer, payload);
      if (callback) callback(response);
    },
    *verifySowingContainer({ payload, callback }, { call, put }) {
      const response = yield call(verifySowingContainer, payload);
      if (callback) callback(response);
    },
    *verifyPickQty({ payload, callback }, { call, put }) {
      const response = yield call(verifyPickQty, payload);
      if (callback) callback(response);
    },
    *getByPsTaskUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByPsTaskUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'saveView',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },
    *adjAllocateQty({ payload, callback }, { call, put }) {
      const response = yield call(adjAllocateQty, payload);
      if (callback) callback(response);
    },
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        taskUuid: payload.taskUuid,
      });
    },
  },
  reducers: {
    saveUnPickingTasks(state, action) {
      return {
        ...state,
        unPickingTasksData: action.payload,
      };
    },
    saveUnSowingTasks(state, action) {
      return {
        ...state,
        unSowingTasksData: action.payload,
      };
    },
    savePickingTasks(state, action) {
      return {
        ...state,
        pickingTasksData: action.payload,
      };
    },
    saveSowingTasks(state, action) {
      return {
        ...state,
        sowingTasksData: action.payload,
      };
    },
    savePickingTask(state, action) {
      return {
        ...state,
        pickingTask: action.payload ? action.payload : [],
      }
    },
    saveSowTask(state, action) {

      return {
        ...state,
        sowTask: action.payload ? action.payload : []
      }
    },
    saveTaskPanel(state, action) {
      return {
        ...state,
        taskPanels: action.payload,
      };
    },
    saveView(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    onView(state, action) {
      return {
        ...state,
        entity: action.entity
      }
    },

    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        taskUuid: action.taskUuid
      }
    }
  }
}
